import { render } from "./WalletBilling.vue?vue&type=template&id=4d10fecf&scoped=true"
import script from "./WalletBilling.vue?vue&type=script&lang=js"
export * from "./WalletBilling.vue?vue&type=script&lang=js"

import "./WalletBilling.vue?vue&type=style&index=0&id=4d10fecf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d10fecf"]])

export default __exports__